export const trimWhitespaces = (value: string): string => {
    if (typeof value !== 'string') {
        return value;
    }
    return value.replace(/\s+/g, ' ').trim();
};

export const removeAllWhitespaces = (value: string): string => value.replace(/\s/g, '');
